import { SerializedConstructor } from '@langchain/core/load/serializable';

import { RunTypeIcon } from '@/components/RunTypeIcon';

import { useManifestMap } from '../Playground/components/manifest/serialized/ManifestConstructorMap';
import { getPlaygroundModelIdFromStoredManifest } from '../Playground/utils/Playground.utils';
import { HubCard } from './HubCard';

export function ModelConfig({
  model,
  hideTools,
}: {
  model: SerializedConstructor;
  hideTools?: boolean;
}) {
  const modelInfo = 'bound' in model.kwargs ? model.kwargs.bound : model;
  const kwargs = modelInfo.kwargs;

  const modelId = getPlaygroundModelIdFromStoredManifest(modelInfo.id, kwargs);
  const manifestMap = useManifestMap();
  const ManifestModel = manifestMap[modelId.join('/')]?.editor;

  return (
    <HubCard
      title={modelId.at(-1)}
      icon={
        <RunTypeIcon
          className="h-4 w-4"
          run={{ name: modelId.at(-1) ?? '', run_type: 'llm' }}
        />
      }
    >
      {ManifestModel != null && (
        <ManifestModel
          variant={'table'}
          value={modelInfo}
          onChange={() => void 0}
          options={{ tools: kwargs?.tools }}
          onOptionsChange={() => void 0}
          readOnly
          hideTools={hideTools}
        />
      )}
    </HubCard>
  );
}
